export const ERRO_PADRAO = "Preencha esse campo para continuar";
export const ERRO_PADRAO_CEP = "Informe um CEP válido";
export const ERRO_PADRAO_DIA = "Informe um dia válido";
export const ERRO_CPF = "CPF inválido";
export const ERRO_PADRAO_GENERO = "Informe um gênero válido";
export const ERRO_PADRAO_ESTADO_CIVIL = "Informe um parentesco válido";
